import PropTypes from 'prop-types';
import { useState } from 'react';
import { css } from 'styled-components';
import trimHtml from 'trim-html';

import { Box } from '@hivebrite/design-system/Box';
import { FakeLink } from '@hivebrite/design-system/Link';

import decodeString from 'hb-react/shared/utils/decodeString';

const ReadMore = ({ text, clamp = 3 }) => {
  const [isOpen, setOpen] = useState(false);
  const { html, more } = trimHtml(decodeString(text), { limit: clamp * 60 });

  return (
    <>
      <Box
        className="ckeditor-content--reset"
        dangerouslySetInnerHTML={{ __html: isOpen ? text : html }}
        display="block"
        css={css`
          word-break: break-word;
        `}
      />

      {more && (
        <FakeLink mt={2} onClick={() => setOpen(!isOpen)}>
          {isOpen ? __('Read less') : __('Read more')}
        </FakeLink>
      )}
    </>
  );
};

ReadMore.propTypes = {
  text: PropTypes.string.isRequired,
  clamp: PropTypes.number,
};

export default ReadMore;
